<template>
  <div ref="elementRef">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import useSetCssHeightVariable from '../composables/use-set-css-height-variable'

interface Props {
  variableName: string
}

const props = defineProps<Props>()

const elementRef = ref<HTMLElement | null>(null)

useSetCssHeightVariable(elementRef, props.variableName)
</script>
